import * as React from "react";
import { useState, Suspense } from "react";
import { normalizeUserContextData } from "../../libs/user_context";
import PageContainer from "../core/PageContainer";
import Breadcrumbs from "../core/Breadcrumbs";
import { wrapComponentForErrors } from "../utility/ErrorHandler";
import OrgPicker from "../core/OrgPicker";
import usePromise from "../hooks/usePromise";
import jfetch from "../../utils/jfetch";
import Panel from "../core/Panel";
import Loader from "../core/Loader";
import ModernCard from "../core/ModernCard"

const ProspectsTable = React.lazy(() =>
  import("../crystal_ball/ProspectsTable")
);

interface IProps {
  userContext: IUserContextData;
}

function CrystalBallAdmin({ userContext: userContextData }: IProps) {
  const [userContext] = useState(normalizeUserContextData(userContextData));
  const [selectedOrgId, setSelectedOrgId] = useState(userContext.org.id);
  const [prospects, { loading }] = usePromise(
    () =>
      jfetch
        .get("/crystal_ball/prospects/org_prospects", {
          org_id: selectedOrgId,
        })
        .then(resp => {
          return import("../../stores").then(
            ({ CrystalBallProspect: CrystalBallProspectStore }) => {
              return resp.prospects.map(p => new CrystalBallProspectStore(p));
            }
          );
        }),
    [selectedOrgId]
  );

  return (
    <PageContainer>
      <Breadcrumbs crumbs={[{ label: "Crystal Ball Admin" }]} />
      <label>Selected Org</label>
      <OrgPicker
        userContext={userContext}
        selectedOrgId={selectedOrgId}
        setSelectedOrgId={setSelectedOrgId}
      />
      <hr />
      <ModernCard title={"Org's Prospects"} ta="left" m="0px">
        <Suspense fallback={null}>
          {loading ? (
            <Loader />
          ) : (
            <ProspectsTable
              prospects={prospects}
              includeAuthor={true}
              openInNewTab={true}
            />
          )}
        </Suspense>
      </ModernCard>
    </PageContainer>
  );
}

export default wrapComponentForErrors(CrystalBallAdmin);



// WEBPACK FOOTER //
// ./app/javascript/components/pages/CrystalBallAdmin.tsx